module.exports = __webpack_public_path__ + "img/client_5.93b7bb67.png";